import './styles.scss';
import logo from '../../images/savetheredwoodsLogo.png'
import { useAuth } from 'reactfire'
import classNames from 'classnames';

export default function CMSHeader(props) {
  const { setSignedIn } = props
  const auth = useAuth()

  const signOut = auth => auth.signOut().then(() => {
    console.log('signed out')
    setSignedIn(v => v + 1)
  });
  return (
    <header className='CMSHeader'>
      <img src={logo} alt='logo' />
      <h1 className='title brotherFontBold'>Dedicated Grove CMS</h1>
      <button className={classNames('button', { hidden: !auth.currentUser})} onClick={() => signOut(auth)} href='#'>Sign out</button>

    </header>
  )
}
